<template>
    <div :class="[
    'header_unit',
     pageType === 'top' || 'manage' ? 'header_bg_white' : 'header_bg_blue'
     ]"
    >
        <div class="header_box">
            <div class="menu_left" style="z-index: 0;">
                <slot name="menu_left"></slot>
            </div>
            <div class="menu_center" style="z-index: 1;">
                <slot name="menu_center"></slot>
            </div>
            <div class="menu_help">
                <slot name="menu_help"></slot>
            </div>
            <div class="menu_right">
                <slot name="menu_right"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        props: {
            pageType: {
                type: String,
                default: 'default',
            },
        }
    }
</script>
